<template>
  <div>
    <div v-if="anyUserOrganizationsAvailable">
      <div>
        <div v-if="anyOrgDocumentsAvailable">
          <v-card
            color="#FFF"
            elevation="0"
            class="empty-alert-div"
          >
            <br>
            <br>
            <p class="empty-alert-msg">
              <v-icon
                size="25"
                color="#C62828"
              >
                mdi-information-outline
              </v-icon>
              No documents found
            </p>
            <br>
            <br>
          </v-card>
        </div>
        <div v-else>
          <v-expansion-panels
            light
            elevation="0"
            solo-inverted
          >
            <v-expansion-panel
              v-for="(item, i) in organizationDocuments"
              :key="i"
              class="content-container"
            >
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between">
                  <div class="sub-container">
                    <div class="d-flex align-center">
                      <v-icon
                        color="#FF7E67"
                        size="18"
                      >
                        mdi-file-document-outline
                      </v-icon>
                      <p class="title-text-style">
                        <font class="value-text-style">
                          {{ item.document_type.name }}
                        </font>
                      </p>
                    </div>
                    <div class="d-flex align-center">
                      <v-chip
                        v-if="item.is_active === true"
                        class="pa-2  expires-in"
                        color="#E6E6E6"
                        x-small
                        dark
                      >
                        <font
                          v-if="item.is_active === true && item.expires_in !== undefined"
                          class="expires-in"
                        >
                          Expires In:
                          {{ item.expires_in }} Days
                        </font>
                        <font
                          v-if="item.is_active === true && item.expires_in === undefined"
                          class="expires-in"
                        >
                          {{ item.expiry_date | convertToLocal }}
                        </font>
                      </v-chip>
                      <v-chip
                        v-if="item.is_active === false"
                        class="pa-2 expires-in"
                        color="#E6E6E6"
                        x-small
                        dark
                      >
                        <font>
                          Expired On:
                          {{ item.expiry_date | convertToLocal }}
                        </font>
                      </v-chip>
                    </div>
                    <div class="upload-class">
                      <v-btn
                        v-if="item.is_active === false"
                        color="#64CA7F"
                        dark
                        x-small
                        elevation="0"
                        @click="renew(item)"
                      >
                        Renew
                      </v-btn>
                    </div>
                  </div>
                  <div class="d-flex align-center justify-end">
                    <p class="title-text-style">
                      <font
                        :color="getColor(item.is_active)"
                        class="status"
                      >
                        {{ item.is_active | statusUpdate }}
                      </font>
                    </p>
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container>
                  <p class="title-text-style">
                    Description:
                    <font class="description-text-style">
                      {{ item.document_type.description }}
                    </font>
                  </p>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div>
          <p
            class="process-header"
            style="margin-bottom:10px"
          >
            Pending Uploads
          </p>
          <hr>
          <br>
          <div v-if="docsNotUploaded.length > 0">
            <v-expansion-panels
              light
              elevation="0"
              solo-inverted
            >
              <v-expansion-panel
                v-for="(item, i) in docsNotUploaded"
                :key="i"
                class="content-container"
              >
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between">
                    <div class="sub-container">
                      <div class="d-flex align-center w-100">
                        <div class="d-flex align-center">
                          <v-icon
                            color="#FF7E67"
                            size="18"
                          >
                            mdi-file-document-outline
                          </v-icon>
                          <p class="title-text-style">
                            <font class="value-text-style">
                              {{ item.name }}
                            </font>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="upload-class">
                      <v-btn
                        color="#64CA7F"
                        dark
                        x-small
                        elevation="0"
                        @click="upload(item)"
                      >
                        Upload
                      </v-btn>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container>
                    <p class="title-text-style">
                      Description:
                      <font class="description-text-style">
                        {{ item.description }}
                      </font>
                    </p>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <div v-else>
            <v-card
              color="#FFF"
              elevation="0"
              class="empty-alert-div"
            >
              <br>
              <p class="empty-alert-msg">
                <v-icon
                  size="25"
                  color="#C62828"
                >
                  mdi-information-outline
                </v-icon>
                No pending uploads
              </p>
              <br>
            </v-card>
          </div>
        </div>
      </div>
      <centre-spinner :loading="loading" />
      <renew-documents
        v-if="showModal"
        :uploading-document-type="uploadingDocumentType"
        :selected-organization="selectedOrganization.organization.external_id"
        :heading-text="headingText"
        :description-text="descriptionText"
        @upload-success="getOrganizationDocuments"
        @closed="showModal = false"
      />
    </div>
    <div v-else>
      <v-card
        color="#FFF"
        elevation="0"
        class="empty-alert-div"
      >
        <br>
        <br>
        <p class="empty-alert-msg">
          <v-icon
            size="25"
            color="#C62828"
          >
            mdi-information-outline
          </v-icon>
          No organizations found
        </p>
        <br>
        <br>
      </v-card>
    </div>
  </div>
</template>
<script>
import spinner from 'src/views/components/SpinnerCentre';
import RenewDocuments from './RenewDocuments.vue';
import moment from 'moment';
export default {
  name: 'OrganizationDocuments',
  components: {
    'centre-spinner': spinner,
    'renew-documents': RenewDocuments,
  },
  filters: {
    capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    statusUpdate (val) {
      if (val === true) {
        return 'Active*';
      }
      return 'Expired';
    },
    convertToLocal (stringDatetime) {
      return moment(stringDatetime).local().format('Do MMMM YYYY');
    },
  },
  data: () => ({
    loading: false,
    showModal: false,
    uploadingDocumentType: null,
    docsNotUploaded: [],
    headingText: '',
    descriptionText: '',
  }),
  computed: {
    userOrganizations () {
      return this.$store.getters[
        'organization/getUserOrganizations'
      ];
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    anyUserOrganizationsAvailable () {
      if (this.userOrganizations.length !== 0) {
        return true;
      }
      return false;
    },
    organizationDocuments () {
      return this.$store.getters[
        'organization/getOrganizationDocuments'
      ];
    },
    anyOrgDocumentsAvailable () {
      if (this.organizationDocuments.length === 0) {
        return true;
      }
      return false;
    },
    workerDocumentTypes () {
      return this.$store.getters['register/getDocumentTypes'];
    },
  },
  async mounted () {
    this.loading = true;
    await this.getUserOrganizations();
    this.anyUserOrganizationsAvailable && await this.getOrganizationDocuments();
    this.loading = false;
  },
  methods: {
    async getUserOrganizations () {
      this.loading = true;
      this.$store.dispatch('register/clearStoredDocumentTypes');
      await this.$store.dispatch('organization/fetchUserOrganizations', {
        params: {
          requestStatus: 'accepted',
        },
      }).then(() => {
        this.getFirstOrganizationDocuments();
      }).catch(() => {
        this.loading = false;
      });
    },
    async getOrganizationDocuments () {
      this.loading = true;
      await this.$store.dispatch('organization/fetchOrganizationDocuments', {
        externalId: this.selectedOrganization.organization.external_id,
      }).then(response => {
        this.fetchWorkerDocumentTypes();
      }).catch(() => {
        this.loading = false;
      });
    },
    getColor (val) {
      if (val === false) {
        return '#C62828';
      }
      return '#2E7D32';
    },
    renew (item) {
      this.showModal = true;
      this.uploadingDocumentType = item.document_type.id;
      this.headingText = 'Renew Document';
      this.descriptionText = 'Please upload your renewed document here.';
    },
    upload (item) {
      this.showModal = true;
      this.uploadingDocumentType = item.id;
      this.headingText = 'Upload Document';
      this.descriptionText = 'Please upload your document here.';
    },
    async fetchWorkerDocumentTypes () {
      this.docsNotUploaded = [];
      if (this.selectedOrganization.worker_category !== null) {
        const orgWorkerCategoryId = this.selectedOrganization.worker_category.id;
        await this.$store.dispatch('register/fetchWorkerDocumentTypes', {
          categoryId: orgWorkerCategoryId,
        }).then(response => {
          this.filterDocuments();
        }).catch(() => {
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
    },
    filterDocuments () {
      for (const doc of this.workerDocumentTypes) {
        const isDocUploaded = this.organizationDocuments.some(item => item.document_type.id === doc.id);
        if (isDocUploaded === false) {
          this.docsNotUploaded.push(doc);
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.content-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  border-radius: 10px !important;
}
p {
  margin-bottom: 0px;
}
.v-icon {
  background-color: transparent;
  padding: 5px;
  border-radius: 50%;
}
.v-card {
  padding: 12px !important;
}
.sub-container {
  display: flex;
  flex-direction: column;

}
.details-container {
  padding-top: 15px;
}
.type-style {
  color: #d31212;
  text-transform: capitalize
}
.expires-in {
  font-size: 12px !important;
  display: flex;
  margin-left: 10px;
}
.v-expansion-panel::before {
  box-shadow: none;

}
.v-expansion-panel-header,
.v-expansion-panel-content>>>.v-expansion-panel-content__wrap {
  padding: 5px !important;
}
.status {
  font-size: 14px;
}
.theme--dark.v-list {
  background-color: white !important;
}
.theme--dark>>>.v-list-item {
  color: #37474F !important;
}
.upload-class {
  margin-left: 10px;
  margin-top: 6px;
}
</style>
